export const getApiBase = (): string => {
  const apiBase = (window as any).__ENV__?.VITE_API_BASE || import.meta.env.VITE_API_BASE || ''
  return apiBase || `${window.location.protocol}//${window.location.hostname}:3001`
}
